import type { RouteObject } from 'react-router-dom';
import { lazyWithReload } from '@shared/lazyWithReload';
import LegacyConnectionPathRedirect from '@shared/components/LegacyConnectionPathRedirect';

const OrganizationsListPage = lazyWithReload(() => import('@organizations/presentation/pages/OrganizationsListPage'));
const AdminOrganizationDetailPage = lazyWithReload(() => import('./pages/AdminOrganizationDetailPage'));
const ConnectionDetailsPage = lazyWithReload(() => import('@connections/presentation/pages/ConnectionDetailsPage'));
const SettingsPage = lazyWithReload(() => import('@shared/settings/pages/SettingsPage'));

export const adminRoutes: RouteObject[] = [
  { index: true, element: <OrganizationsListPage /> },
  { path: 'organizations', element: <OrganizationsListPage /> },
  { path: 'organizations/:slug', element: <AdminOrganizationDetailPage /> },
  { path: 'connections/:id', element: <ConnectionDetailsPage /> },
  // Redirección permanente: marcadores y emails ya enviados (design D2).
  { path: 'klons/:id', element: <LegacyConnectionPathRedirect /> },
  { path: 'settings', element: <SettingsPage /> },
];
